import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Form, Input, Button } from "antd";
import { Spin, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getOrganizationMappings, getUserIds, resetProvisioning } from "../../utils/api";
import "./AddUser.css";

const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />
);

function AddUser({ navStore, authStore }) {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [userCode, setUserCode] = useState("");
    const [form] = Form.useForm();


    const onFinish = async () => {
        setError("");
        setSubmitting(true);
        try {
            if (authStore.userRole === "admin") {
                await resetProvisioning(userCode);
            }
            else if (authStore.userRole === "org_admin") {
                let userids = await getOrganizationMappings(authStore.user.organization_details.id);
                userids = userids.map((x) => x.user_id).sort();
                if (userids.includes(userCode)) {
                    await resetProvisioning(userCode);
                } else {
                    throw new Error("User code doesn't exists in organization");
                }
            }
            setUserCode("");
            form.resetFields();
            notification.open({
                message: "Reset Provisioning",
                description: "Reset Provisioning Successfull",
            });
            navigate("/reset-provisioning");
        } catch (e) {
            setSubmitting(false);
            setError(e.response?.data?.message || e.message);
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
    }, []);

    return (
        <div className="AddUser">
            <div className="AddUser__wrapper">
                <div className="AddUser__container">
                    <h2>Reset Provisioning</h2>
                    <Form
                        name="basic"
                        initialValues={{ remember: true }}
                        autoComplete="off"
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            className="AddUser__item"
                            label="User Code"
                            name="userCode"
                            rules={[{ required: true, message: "Please enter user code to reset provisioning" }]}
                        >
                            <Input onChange={(e) => setUserCode(e.target.value)} />
                        </Form.Item>

                        {error && <div className="error">{error}</div>}
                        <Form.Item>
                            <Button type="primary" htmlType="submit" block>
                                {submitting && <Spin indicator={antIcon} />}
                                {!submitting && <span> Reset Provisioning</span>}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default observer(AddUser);
